export const contentPlan = {
  title: 'Plan de Contenidos',
  subtitle: 'Genera un plan de contenidos a partir de una investigación de palabras clave',
  keywordResearch: {
    placeholder: 'Selecciona un keyword research...',
    empty: 'No hay keyword researches disponibles',
  },
  generate: {
    button: 'Generar Plan',
    generating: 'Generando...',
    hint: 'Esto puede tardar unos minutos',
  },
  status: {
    pending: 'Pendiente',
    generating: 'Generando...',
    completed: 'Completado',
    failed: 'Fallido',
  },
  list: {
    emptyTitle: 'Aún no hay planes de contenidos',
    emptyDescription: 'Seleccioná keywords desde una investigación de keywords para crear un plan de contenidos.',
    goToKeywordResearch: 'Ir a Investigación de Keywords',
    importFromCsv: 'Importar desde CSV',
    columns: {
      name: 'Nombre',
      status: 'Estado',
      keywords: 'Keywords',
      contents: 'Contenidos',
      approval: 'Aprobación',
      created: 'Creado',
    },
    deleteDialog: {
      title: 'Eliminar plan de contenidos',
      description: 'Esta acción no se puede deshacer. El plan de contenidos y todos sus items serán eliminados permanentemente.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
      deleting: 'Eliminando...',
    },
    renameDialog: {
      title: 'Renombrar plan de contenidos',
      label: 'Nombre del plan',
      cancel: 'Cancelar',
      confirm: 'Guardar',
      saving: 'Guardando...',
    },
  },
  toast: {
    createSuccess: 'Generación de plan de contenidos iniciada',
    downloadSuccess: 'Plan de contenidos descargado',
    deleteSuccess: 'Plan de contenidos eliminado',
    renameSuccess: 'Plan de contenidos renombrado',
    itemDeleteSuccess: 'Item eliminado del plan',
    bulkItemDeleteSuccess: '{{count}} items eliminados del plan',
    bulkTypeUpdateSuccess: 'Tipo cambiado en {{count}} items',
    retryLinkedinSuccess: 'Búsqueda en LinkedIn completada',
    removeLinkedinPostSuccess: 'Post de LinkedIn eliminado',
    updateSuccess: 'Item actualizado',
    approveSuccess: 'Item aprobado',
    rejectSuccess: 'Item rechazado',
  },
  errors: {
    generateFailed: 'Error al generar el plan de contenidos',
    downloadFailed: 'Error al descargar el plan de contenidos',
    deleteFailed: 'Error al eliminar el plan de contenidos',
    renameFailed: 'Error al renombrar el plan de contenidos',
    itemDeleteFailed: 'Error al eliminar el item',
    bulkItemDeleteFailed: 'Error al eliminar los items',
    bulkTypeUpdateFailed: 'Error al cambiar el tipo de los items',
    retryLinkedinFailed: 'Error al reintentar búsqueda en LinkedIn',
    removeLinkedinPostFailed: 'Error al eliminar post de LinkedIn',
    noKeywords: 'No hay keywords para generar el plan',
    updateFailed: 'Error al actualizar el item',
    missingParams: 'Faltan parámetros requeridos',
    loadKeywordsFailed: 'Error al cargar los detalles de las keywords',
  },
  confirmation: {
    subtitle: '{{count}} keywords seleccionadas para planificar',
    back: 'Volver',
    loadingKeywords: 'Cargando detalles de keywords...',
    settingsTitle: 'Configuración del plan',
    planName: 'Nombre del Plan',
    planNamePlaceholder: 'ej. Plan Marzo 2026',
    planNameHelper: 'Elegí un nombre descriptivo para identificar este plan después',
    context: {
      instructionsLabel: 'Indicaciones generales (opcional)',
      instructionsPlaceholder:
        'ej. Contenido para PyMEs de México; los temas de normativa laboral deben citar la reforma 2026; no cubrir carreras universitarias',
      instructionsHelper: 'Guía que se aplica a todos los contenidos de este plan',
      excludeRankedLabel: 'Excluir keywords que ya rankean en el top 10',
      excludeRankedHelper:
        'Por defecto se saltean las keywords para las que tu sitio ya rankea en el top 10 de Google. Desactivá esta opción para generar contenido igual.',
      focusTitle: 'Enfoque por keyword (opcional)',
      focusHelper:
        'Seleccioná keywords y asignales un enfoque en común, o definí uno por keyword — sirve para desambiguar la intención y sumar restricciones',
      focusLabel: 'Enfoque',
      focusPlaceholder:
        'ej. decoración de interiores, NO la carrera universitaria; mantener normativa 2025',
      selectAll: 'Seleccionar todas',
      selectedCount: '{{count}} seleccionadas',
      selectAllResults: 'Seleccionar todos los resultados ({{count}})',
      applyToSelection: 'Asignar enfoque a la selección ({{count}})',
      applyToCollection: 'Enfoque a la colección ({{count}})',
      searchPlaceholder: 'Filtrar keywords...',
      noSearchResults: 'Ninguna keyword coincide con el filtro',
      noKeywords: 'No hay keywords para mostrar',
      apply: 'Aplicar',
      removeFocus: 'Quitar enfoque',
      charCount: '{{current}}/{{max}}',
      ungroupedGroup: 'Sin agrupar',
      groupCount: '{{count}} keywords',
      selectGroup: 'Seleccionar todas las keywords de {{name}}',
    },
  },
  csvImport: {
    pageTitle: 'Importar plan de contenidos',
    pageSubtitle: 'Traé tu plan existente a Referent en tres pasos',
    rowsPageTitle: 'Importar filas desde CSV',
    rowsPageSubtitle: 'Agregá filas a tu plan en tres pasos',
    stepper: {
      upload: 'Subir',
      mapping: 'Mapear',
      preview: 'Revisar',
    },
    steps: {
      upload: {
        title: 'Subí tu CSV',
        descriptionCreate: 'Dale un nombre a tu plan y adjuntá el archivo.',
        descriptionAppend: 'Adjuntá el archivo.',
        templateTitle: '¿No tenés un archivo listo?',
        templateDescription: 'Descargá la plantilla con las columnas correctas y una fila de ejemplo.',
        downloadTemplate: 'Descargar plantilla',
        planNameLabel: 'Nombre del plan',
        planNamePlaceholder: 'Plan Marzo 2026',
        dropzonePrimary: 'Soltá tu CSV acá',
        dropzoneSecondary: 'o hacé clic para seleccionar',
        dropzoneHint: '.csv hasta 10 MB',
        parsing: 'Procesando tu archivo...',
        continue: 'Continuar',
      },
      mapping: {
        title: 'Mapeá tus columnas',
        description: 'Asociá cada campo del plan con una columna de tu CSV',
        requiredSection: 'Campos requeridos',
        optionalSection: 'Campos opcionales',
        requiredMark: '*',
        mappedBadge: 'Mapeado',
        noneOption: '— Ninguno —',
        duplicateHeader: 'Esta columna ya está usada en otro campo',
        preview: 'Previsualizar filas',
        back: 'Volver',
      },
      preview: {
        title: 'Revisá las filas',
        description: 'Las filas válidas ya están seleccionadas. Destildá las que quieras saltear.',
        statsValid: 'Válidas',
        statsInvalid: 'Inválidas',
        statsTotal: 'Filas totales',
        tabAll: 'Todas',
        tabValid: 'Válidas',
        tabInvalid: 'Inválidas',
        columnRow: 'Fila',
        columnMainKeyword: 'Keyword principal',
        columnTitle: 'Título',
        columnType: 'Tipo',
        columnVolume: 'Volumen',
        columnStatus: 'Estado',
        importButton: 'Importar {{count}} filas',
        back: 'Volver',
        importing: 'Importando...',
        emptySelection: 'Seleccioná al menos una fila válida para continuar',
      },
    },
    fields: {
      mainKeyword: 'Keyword principal',
      title: 'Título',
      type: 'Tipo',
      contentApproach: 'Enfoque de contenido',
      interactionGroup: 'Grupo de interacción',
      aiFocusFactor: 'Factor de foco IA',
      volume: 'Volumen',
      category: 'Categoría',
      secondaryKeywords: 'Keywords secundarias',
      entities: 'Entidades',
      relatedPrompts: 'Prompts relacionados',
      deadline: 'Fecha límite',
    },
    dialog: {
      title: 'Importar filas desde CSV',
      triggerButton: 'Importar filas',
    },
    toast: {
      createdSuccess: 'Plan de contenidos creado con {{count}} ítems',
      appendedSuccess: 'Se agregaron {{count}} filas al plan',
      error: 'La importación falló — probá de nuevo',
    },
    rowErrors: {
      REQUIRED_EMPTY: 'El campo requerido está vacío',
      INVALID_ENUM: 'Valor inválido "{{value}}" — se esperaba: {{expected}}',
      INVALID_INTEGER: 'No es un número entero válido',
      INVALID_DATE: 'Formato de fecha inválido — se espera AAAA-MM-DD',
    },
    apiErrors: {
      CONTENT_PLAN_CSV_IMPORT_PARSE_ERROR:
        'No pudimos leer el archivo CSV. Verificá que sea un CSV válido e intentá de nuevo.',
      CONTENT_PLAN_CSV_IMPORT_EMPTY: 'El archivo no tiene filas de datos.',
      CONTENT_PLAN_CSV_IMPORT_INVALID_PAYLOAD:
        'La solicitud es inválida. Recargá la página e intentá de nuevo.',
      CONTENT_PLAN_CSV_IMPORT_INVALID_FIELD_MAP:
        'Revisá el mapeo de columnas: hay campos sin asignar o columnas repetidas.',
      CONTENT_PLAN_CSV_IMPORT_NO_VALID_ROWS: 'No hay filas válidas seleccionadas para importar.',
      CONTENT_PLAN_CSV_IMPORT_CREATION_FAILED:
        'No pudimos crear el plan de contenidos. Intentá de nuevo.',
      generic: 'Algo salió mal con la importación. Intentá de nuevo.',
    },
  },
  progress: {
    title: 'Generando tu plan de contenidos',
    steps: {
      analyzing_serp: 'Analizando SERPs',
      filtering: 'Filtrando keywords ya posicionadas',
      researching: 'Investigando respuestas de LLMs, sub-queries de IA y LinkedIn',
      expanding_keywords: 'Expandiendo keywords secundarias',
      generating: 'Generando plan de contenidos',
      verifying: 'Verificando menciones de competidores',
    },
    excludedKeywords: '{{count}} keywords excluidas (ya posicionadas en top 10)',
    excludedReason: 'Motivo',
    skippedReasons: {
      filtering: 'No hay sitio web de empresa configurado',
    },
  },
  result: {
    subtitle: '{{count}} contenidos generados',
    exportCsv: 'Descargar CSV',
    columns: {
      mainKeyword: 'Keyword Principal',
      title: 'Título',
      type: 'Tipo',
      contentApproach: 'Enfoque',
      interactionGroup: 'Interacción',
      aiFocusFactor: 'Factor IA',
      volume: 'Volumen',
      category: 'Categoría',
      secondaryKeywords: 'Keywords Secundarias',
      entities: 'Entidades',
      relatedPrompts: 'Prompts Relacionados',
      deadline: 'Fecha Límite',
      linkedinPosts: 'Posts de LinkedIn',
      action: 'Acción',
      status: 'Estado',
    },
    saveChanges: 'Guardar Cambios',
    noCategory: 'Sin categoría',
    editCategory: 'Editar categoría',
    noLinkedinPosts: 'No se encontraron posts de LinkedIn',
    retryLinkedin: 'Reintentar búsqueda en LinkedIn',
    removeLinkedinPost: 'Eliminar post de LinkedIn',
    create: 'Crear',
    created: 'Creado',
    bulkSelected: '{{count}} items seleccionados',
    bulkMixedWarning: 'Selecciona solo blogs o solo landings',
    bulkCreateBlogs: 'Crear {{count}} Blogs',
    bulkCreateLandings: 'Crear {{count}} Landings',
    bulkDeleteSelected: 'Eliminar seleccionados',
    bulkAddTag: 'Agregar tag',
    bulkChangeType: 'Cambiar tipo',
    edit: 'Editar',
    deleteItem: 'Eliminar item',
    deleteDialog: {
      title: 'Eliminar item',
      description: 'Este item será eliminado del plan.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
    },
    bulkDeleteDialog: {
      title: 'Eliminar items seleccionados',
      description: '{{count}} items serán eliminados del plan. Esta acción no se puede deshacer.',
    },
    hintCommaSeparated: 'Separar con comas',
    hintOnePerLine: 'Un prompt por línea',
    tags: {
      addTag: 'Agregar etiqueta',
      edit: 'Editar',
      searchTags: 'Buscar etiquetas...',
      noTagsFound: 'Sin resultados',
      noTagsAvailable: 'No hay etiquetas disponibles',
      createNewTag: 'Crear nueva etiqueta',
      tagNamePlaceholder: 'Nombre de la etiqueta',
      tagColor: 'Color:',
      cancel: 'Cancelar',
      create: 'Crear',
      systemTagTooltip: 'Se asigna automáticamente al redactarse el contenido',
      bulkAssignSuccess: 'Tag agregado a {{count}} ítems',
      createFailed: 'No se pudo crear el tag',
      removeTag: 'Quitar tag {{name}}',
    },
  },
  trendOrigin: {
    label: 'De una oportunidad de tendencia',
    direction: {
      rising: 'En alza',
      seasonal: 'Estacional',
      flat: 'Estable',
      declining: 'En baja',
      unknown: 'Tendencia desconocida',
    },
    discoveredOn: 'Descubierta {{date}}',
  },
  detail: {
    backToList: 'Volver a planes',
    errorTitle: 'Error al cargar el plan',
    errorDescription: 'No se pudieron cargar los contenidos de este plan.',
  },
  failed: {
    title: 'Error en la Generación',
    message: 'Ocurrió un error al generar el plan de contenidos.',
    retry: 'Reintentar',
    backToList: 'Volver a planes',
  },
  itemStatus: {
    pending: 'Pendiente',
    approved: 'Aprobado',
    rejected: 'Rechazado',
  },
  filters: {
    search: 'Buscar por keyword o título...',
    status: 'Estado',
    type: 'Tipo',
    typeBlog: 'Blog',
    typeLanding: 'Landing',
    tags: 'Etiquetas',
    all: 'Todos',
    noResults: 'No hay contenidos que coincidan con los filtros',
  },
  findReplace: {
    toggle: 'Buscar y reemplazar',
    searchPlaceholder: 'Término a buscar...',
    replacePlaceholder: 'Reemplazar por...',
    matchCase: 'Distinguir mayúsculas',
    replace: 'Reemplazar',
    replaceCurrentAriaLabel: 'Reemplazar la coincidencia actual',
    replaceAll: 'Reemplazar todo',
    requiredFieldWarning: 'No se puede vaciar un campo obligatorio. Se omitió el reemplazo.',
    counter: '{{current}}/{{total}}',
    previousMatch: 'Coincidencia anterior',
    nextMatch: 'Coincidencia siguiente',
    close: 'Cerrar',
    noMatches: 'Sin coincidencias en el plan',
    confirm: {
      title: 'Reemplazar en todo el plan',
      description:
        'Se reemplazará el término en todo el plan — incluidas las filas ocultas por los filtros activos: alrededor de {{occurrences}} coincidencias en {{rows}} filas.',
      note: 'Las coincidencias en campos obligatorios se omiten si dejarían el campo vacío, por lo que el total final puede ser menor.',
      warning: 'Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      confirm: 'Reemplazar todo',
      replacing: 'Reemplazando...',
    },
    result: {
      summary: 'Se actualizaron {{items}} filas ({{occurrences}} coincidencias reemplazadas).',
      skippedNote:
        'Algunos campos obligatorios se dejaron sin cambios para no vaciarlos ({{rows}}).',
    },
    toast: {
      success: 'Término reemplazado en {{rows}} filas',
    },
    errors: {
      failed: 'No se pudo reemplazar el término',
    },
  },
  approval: {
    approve: 'Aprobar',
    reject: 'Rechazar',
    summary: {
      approved: '{{count}} aprobados',
      pending: '{{count}} pendientes',
      rejected: '{{count}} rechazados',
    },
  },
} as const
